import { Injectable } from '@angular/core';
import { LocalStorageService } from '../local-storage/local-storage.service';

@Injectable({ providedIn: 'root' })
export class CookieConsentService {
  private key = 'cookie_consent';

  constructor(private localStorageService: LocalStorageService) {}

  async hasConsent() {
    const cookie = await this.localStorageService.get(this.key);
    return cookie === true || cookie === 'true';
  }

  giveConsent() {
    this.localStorageService.set(this.key, true);
  }
}
